(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["serie-atelier"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initCarousel = (carousel) => {
      if (carousel.dataset.atelierTrustReady === 'true') return;

      const track = carousel.querySelector('[data-atelier-trust-track]');
      const previous = carousel.querySelector('[data-atelier-trust-prev]');
      const next = carousel.querySelector('[data-atelier-trust-next]');
      const items = Array.from(track?.children || []);

      if (!track || !previous || !next || items.length === 0) return;
      carousel.dataset.atelierTrustReady = 'true';

      const activeIndex = () => {
        const center = track.scrollLeft + (track.clientWidth / 2);
        let closestIndex = 0;
        let closestDistance = Infinity;

        items.forEach((item, index) => {
          const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
          const distance = Math.abs(itemCenter - center);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const updateButtons = () => {
        const index = activeIndex();
        previous.disabled = index === 0;
        next.disabled = index === items.length - 1;
      };

      const navigate = (direction) => {
        const index = Math.max(0, Math.min(items.length - 1, activeIndex() + direction));
        const item = items[index];
        const left = item.offsetLeft - ((track.clientWidth - item.offsetWidth) / 2);
        track.scrollTo({ left, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => navigate(-1));
      next.addEventListener('click', () => navigate(1));
      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
    };

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-atelier-trust-carousel]').forEach(initCarousel);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
